import styled from 'styled-components';
import { mixins } from '@jarvis/react-portal-addons';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 16px;
  z-index: 1;
  max-width: 1588px;
  padding-bottom: 16px;

  ${mixins.md(`
    gap: 20px;
  `)}

  ${mixins.lg(`
    gap: 24px;
    padding: 24px 32px;
  `)}

  ${mixins.xxxl(`
    margin: auto;
    padding: 28px 36px;
    gap: 28px;
  `)}
`;

export const Grid = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(12, 1fr);
  position: relative;
  max-width: 1660px; // 1920 is the max content width (side menu + content area), side menu is 260px.
  z-index: 1;
  padding: 0 16px;

  ${mixins.md(`
    gap: 20px;
    padding: 0 28px;
  `)}

  ${mixins.lg(`
    gap: 24px;
    padding: unset;
  `)}

  ${mixins.xxxl(`
    gap: 28px;
  `)}
`;

export const StatusContainer = styled.div`
  grid-column: 1 / span 12;

  align-self: center;
  display: flex;
  justify-content: center;
  ${mixins.xl(`
    grid-column: 1 / span 4;
  `)}
`;

export const UsageContainer = styled.div`
  grid-column: 1 / span 12;

  ${mixins.xl(`
    grid-column: 5 / span 8;
  `)}
`;
